<script lang="ts">
	import { IconSprite } from '@shared/svelte';
</script>

<div class="mv-app-layout flex min-h-screen w-full">
	<div class="z-fixed">
		<slot name="drawer-left" />
		<slot name="drawer-right" />
	</div>

	<div class="mv-content max-w-screen box-border flex flex-grow flex-col">
		<div class="z-toolbar">
			<slot name="app-bar" />
		</div>
		<slot />
	</div>

	<slot name="fab" />
	<slot name="snackbar" />
	<slot name="banner" />
	<slot name="notification" />
	<slot name="dialog" />

	<slot name="footer" />
</div>

<IconSprite />

<!--
@component
The base layout component.
- usage:

	```svelte
	<BaseLayout>
		<span slot="drawer-left">
		<span slot="drawer-right">
		<span slot="app-bar">

		<slot>
			content
		</slot>

		<span slot="fab">
		<span slot="snackbar">
		<span slot="banner">
		<span slot="notification">
		<slot name="dialog" />
		<span slot="footer">
	</BaseLayout>
	```
-->
